import { useEffect } from "react";
import { Outlet, useNavigate } from "fusion-plugin-react-router";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const uberCode = sessionStorage.getItem("uberCode");
      if (!uberCode) {
        navigate("/");
      }
    };

    checkAuth();
  }, [navigate]);

  return <Outlet />;
};

export default ProtectedRoute;
